import { createContext, useContext } from 'react';
import { Me } from './portalApi';

// ---- P1-B customer portal ----
export const PortalSessionContext = createContext<{ me: Me | null; code: string }>({ me: null, code: '' });
export const usePortalSession = () => useContext(PortalSessionContext);
// ---- end P1-B ----
